import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './dtp/app.module';
import { EnvService } from 'env/env.service';
import { msalInstance } from './core/core.module';
const environments = new EnvService()
if (environments.get().production) {
  enableProdMode();
}
msalInstance.initialize()
  .then(() => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  })
  .catch(err => console.error('MSAL initialization failed:', err));
